import React from 'react';
import { IntercomAPI } from 'react-intercom';
import SectionTitle from '../SectionTitle';
import styles from './styles.scss';

function Faq () {
  return (
    <div>
      <div className="row">
        <div className="col-md-9 col-center">
          <h1 className={`${styles.heading} bold-italics blue text-center mb50`}>
            What happens if I don't like it?
          </h1>
          <SectionTitle color="#492EFD">
            <h3>YOU WILL.</h3>
          </SectionTitle>
          <h1 className="bold-italics blue text-center mt50 mb50">
            but...
          </h1>
        </div>
      </div>
      <div className={styles.faq}>
        <div className="row">
          <div className="col-sm-6">
            <h4 className="bold">
              What if I don't like the design in the end?
            </h4>
            <p>
              That rarely happens, but if it does, we'll assign your project to
              another designer free of charge and iterate until we meet your
              satisfaction.
            </p>
            <p>
              If it still isn't working out, you'll get a 100% refund on your
              upfront payment.
            </p>
          </div>
          <div className="col-sm-6">
            <h4 className="bold">
              Do you exclusively design for web?
            </h4>
            <p>
              No, actually! We have a number of designers in our network that
              specialize in branding, logo design and animation as well.
              You can contact us <a onClick={() => IntercomAPI('show')}>here to learn more.</a>
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <h4 className="bold">
              Can I choose my own designer?
            </h4>
            <p>
              We actually do that for you! Finding and managing design talent is
              a job of its own and can cause miscommunications and delays. We
              believe that pairing each designer with a product manager is the
              best way to ensure success.
            </p>
          </div>
          <div className="col-sm-6">
            <h4 className="bold">
              Do you build and host the site?
            </h4>
            <p>
              We don't. DesignCue will provide you with a ready-to-build
              vector file for your development team or dev of choice to code
              for you. Everything will be packaged, including fonts, icons,
              photos, and UI styles.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Faq;



// WEBPACK FOOTER //
// ./src/components/Faq/index.js